module.exports = __webpack_public_path__ + "static/media/img-1.0308fcf9.png";